import {DescriptionText, FlexContainer, H1Text, H2Text, Hr} from "../../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../../helper";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyformatter from "../../../../../utils/currencyformatter";

type Props = {
  account: Object,
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
  eventDetails: Object,
  selectedSeats: Array<Object>,
  cancelUrlLink: String,
}

const Header = (props:Props) => {
  const { account, payment, bankImageUrl, whiteLabel, eventDetails, selectedSeats, cancelUrlLink } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;

  const ossatId = [
    "eventpageorderlink-94d9318db7414a2bbbf5c57a8a593277",
  ];
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader 
      paymentCheckout={true} 
      bankImageUrl={bankImageUrl} 
      largeLogo={largeLogo} 
      whiteLabel={whiteLabel}
      cancelUrlLink={cancelUrlLink}
    >
      <FlexContainer {...customContainerProps}>
        <H1Text {...customPrimaryHeadingProps}>
          Payment Checkout
        </H1Text>
        <Hr/>
        <FlexContainer {...customFlexContainerProps}>
          {
            ossatId.includes(props.payment?.gid) ? (
              <DescriptionText {...customDescriptionProps}>
                Payment For :&nbsp;
              </DescriptionText>
            ) : (
                <H2Text {...customSecondaryHeadingProps}>
                  Payment For
                </H2Text>
            )
          }
          <DescriptionText {...customDescriptionProps}>
            { payment?.account && <p>{payment?.account.name}</p> }
          </DescriptionText>
          {
            selectedSeats && selectedSeats.length !== 0 && (
              <>
                {
                  selectedSeats.map((item) => (
                    item.numSelected ?
                      <DescriptionText {...customDescriptionProps}>{item.seatId} - {item.numSelected}</DescriptionText>
                    :<DescriptionText {...customDescriptionProps}>{item.seatId}</DescriptionText>
                  ))
                }
              </>
            )
          }
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          {
            ossatId.includes(props.payment?.gid) ? (
              <DescriptionText {...customDescriptionProps}>
                Amount Payable :&nbsp;
              </DescriptionText>
            ) : (
                <H2Text {...customSecondaryHeadingProps}>
                  Amount Payable
                </H2Text>
            )
          }
          <DescriptionText {...customDescriptionProps}>
            {payment ? `${currencyformatter((payment && (payment?.amount / 100.0)), payment?.currency.name)}` : null }
          </DescriptionText>
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
